<template>
  <div>
    <div class="aws-sku-descriptions">
      <div class="aws-sku-descriptions-image">
        <el-image :src="displayImage" :preview-src-list="imageList" />
      </div>

      <div class="aws-sku-descriptions-info">
        <div class="descriptions">
          <el-row class="descriptions-row">
            <el-col :span="8" class="descriptions-item">
              <div class="descriptions-label">物料编号</div>
              <div class="descriptions-content">
                {{ data.skuMaterialNo }}
              </div>
            </el-col>
            <el-col :span="8" class="descriptions-item">
              <div class="descriptions-label">物料类型</div>
              <div class="descriptions-content">
                {{ data.materialCategoryName }}
              </div>
            </el-col>
            <el-col :span="8" class="descriptions-item">
              <div class="descriptions-label">所属品牌</div>
              <div class="descriptions-content">
                {{ data.brandName }}
              </div>
            </el-col>
          </el-row>

          <el-row class="descriptions-row">
            <el-col :span="12" class="descriptions-item">
              <div class="descriptions-label">物料名称</div>
              <div class="descriptions-content">
                {{ data.materialName || '' }}
              </div>
            </el-col>
            <el-col :span="12" class="descriptions-item">
              <div class="descriptions-label">英文名称</div>
              <div class="descriptions-content">
                {{ data.materialNameEn || '' }}
              </div>
            </el-col>
          </el-row>
          <el-row class="descriptions-row">
            <el-col :span="12" class="descriptions-item">
              <div class="descriptions-label">材质</div>
              <div class="descriptions-content">
                {{ data.materialDesc || '' }}
              </div>
            </el-col>
            <el-col :span="12" class="descriptions-item">
              <div class="descriptions-label">规格尺寸</div>
              <div class="descriptions-content">
                {{ data.materialSpec || '' }}
              </div>
            </el-col>
          </el-row>

          <el-row class="descriptions-row">
            <el-col :span="4" class="descriptions-item">
              <div class="descriptions-label">指定供应商</div>
              <div class="descriptions-content">
                {{
                  data.isSpecify ? (data.isSpecify == 'Y' ? '是' : '否') : ''
                }}
              </div>
            </el-col>
            <el-col :span="8" class="descriptions-item">
              <div class="descriptions-label">供应商</div>
              <div class="descriptions-content">
                {{ data.scmName || '' }}
              </div>
            </el-col>
            <el-col :span="4" class="descriptions-item">
              <div class="descriptions-label">物料单位</div>
              <div class="descriptions-content">
                {{ data.v_materialUnit }}
              </div>
            </el-col>
            <el-col :span="4" class="descriptions-item">
              <div class="descriptions-label">合计用量</div>
              <div class="descriptions-content">
                {{ data.totalProducts || '0' }}
                {{ data.v_materialUnit || '' }}
              </div>
            </el-col>
            <el-col :span="4" class="descriptions-item">
              <div
                class="descriptions-content"
                style="display: flex; justify-content: center;align-items: center;"
              >
                <b-button
                  size="sm"
                  variant="outline-primary"
                  @click="editMaterial"
                  style="height: 31px;"
                >
                  {{ $l('INDEX.material_btn_edit') || '编辑' }}
                </b-button>
                <b-button
                  size="sm"
                  class="ml-3"
                  variant="outline-danger"
                  @click="delMaterial"
                  style="height: 31px;"
                >
                  {{ $l('INDEX.material_btn_del') || '删除' }}
                </b-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <div class="aws-sku-descriptions">
      <div class="aws-sku-descriptions-info">
        <div class="descriptions">
          <el-row class="descriptions-row">
            <el-col :span="24" class="descriptions-item">
              <div
                v-if="!disabled"
                class="descriptions-label"
                style="text-align: center;min-width: 120px;width: 120px;"
              >
                说明文件
              </div>
              <div class="descriptions-content">
                <FileList
                  :items="data.docList || []"
                  :disabled="true"
                  :cols="4"
                  :layout="{ size: true, delete: true }"
                ></FileList>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="aws-sku-descriptions">
      <div class="aws-sku-descriptions-info">
        <div class="descriptions">
          <el-row class="descriptions-row">
            <el-col :span="24" class="descriptions-item">
              <div
                class="descriptions-label "
                style="text-align: center;min-width: 120px;width: 120px;"
              >
                使用范围
              </div>
              <div class="descriptions-content">
                <div>
                  <div class="mb-1">
                    {{ data.v_materialRange || '' }}
                  </div>
                  <div
                    v-if="
                      data.materialRange == 'A' ||
                        data.amzSkuMaterialGroup == 'sewing'
                    "
                  >
                    <MaterialSpec :specMaterialList="data.specMaterialList" />
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FileList from '@/views/ecom/components/file-list'
import MaterialSpec from '../material-spec'
export default {
  components: {
    FileList,
    MaterialSpec,
  },
  props: {
    data: { type: Object, default: () => {} },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {}
  },
  computed: {
    imageList() {
      const { imageList } = this.data
      return this.sortImageList(imageList || [])
    },
    displayImage() {
      if (this.imageList && this.imageList.length > 0) {
        return this.imageList[0] || '/image/static/img/nopic-square.jpg'
      }
      return '/image/static/img/nopic-square.jpg'
    },
  },
  methods: {
    editMaterial() {
      this.$emit('editMaterial')
    },
    delMaterial() {
      this.$emit('delMaterial')
    },
    sortImageList(sortedList) {
      if (!sortedList.length) return []
      return sortedList.map((item) => item.originImageUrl)
    },
  },
}
</script>

<style lang="scss" scoped>
.aws-sku-descriptions {
  display: flex;
  align-items: stretch;
  flex-direction: row;
  .aws-sku-descriptions-image {
    padding: 10px;
    border: 1px solid #ebeef5;
    border-right: none;
    display: flex;
    align-items: center;
    justify-content: center;
    .el-image {
      width: 100px;
      height: 100px;
    }
  }

  .aws-sku-descriptions-info {
    flex-grow: 1;
  }
}

.descriptions {
  --padding: 10px 12px;

  --border-width: 1px;
  --border-style: solid;
  --border-color: #ebeef5;

  --label-width: 110px;
  --label-bg: #f5f7fa;

  border-width: var(--border-width);
  border-color: var(--border-color);
  border-left-style: var(--border-style);
  border-bottom-style: var(--border-style);

  .descriptions-row {
    display: flex;
    align-items: stretch;
    .descriptions-item {
      display: flex;
      align-items: stretch;
      flex-direction: row;
      .descriptions-label {
        font-size: 14px;
        color: #909399;
        width: var(--label-width);
        min-width: var(--label-width);
        padding: var(--padding);
        border-width: var(--border-width);
        border-color: var(--border-color);
        border-top-style: var(--border-style);
        border-right-style: var(--border-style);
        background-color: var(--label-bg);
      }

      .descriptions-content {
        flex-grow: 1;
        font-size: 14px;
        color: #606266;
        padding: var(--padding);
        border-width: var(--border-width);
        border-color: var(--border-color);
        border-top-style: var(--border-style);
        border-right-style: var(--border-style);
        word-break: break-all;
      }
    }
  }
}
</style>
